import { useCallback } from 'react';

import { getCurrentLocation as fetchCurrentLocation, type LocationCoords } from './LocationService';

type UseLocationPermissionResult = {
  getCurrentLocation: () => Promise<LocationCoords | null>;
};

export const useLocationPermission = (): UseLocationPermissionResult => {
  const getCurrentLocation = useCallback(() => fetchCurrentLocation(), []);

  return { getCurrentLocation };
};
